import gql from 'graphql-tag';

const DELETE_REALTOR_FOLLOW_UP = gql` 
  mutation deleteRealtorFollowUp($input: RealtorFollowUpDeleteInput!) {
    deleteRealtorFollowUp(input: $input) {
      message
      code
    }
  }
`;

export default DELETE_REALTOR_FOLLOW_UP;